import {
  GET_SECTOR_PROVIDERS,
  GET_SECTOR_PROVIDERS_ERROR,
  GET_SECTOR_PROVIDERS_SUCCESS
} from './SectorProvidersSection.actions'

const sectorProvidersSectionState = {
  data: [],
  error: null,
  loading: false,
  page: 1,
  pages: 1,
  records: 1
}

/**
 * The sector providers section's reducer.
 */
const sectorProvidersSectionReducer = (state = sectorProvidersSectionState, { payload, type }) => {
  switch (type) {
    case GET_SECTOR_PROVIDERS: {
      return { ...state, loading: true }
    }
    case GET_SECTOR_PROVIDERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SECTOR_PROVIDERS_SUCCESS: {
      return { ...state, loading: false, ...payload }
    }
    default: {
      return state
    }
  }
}

export default sectorProvidersSectionReducer
